<ng-container *ngIf="pixelImpression">
  <img 
    aria-hidden="true" 
    style="opacity: 0; pointer-events: none;" 
    [src]="pixelUrl" 
    width="1" height="1" />
</ng-container>

<ng-container *ngIf="!offerSet">
    <div class="spinner-container">
      <ng-container *ngIf="!error">
        <app-spinner></app-spinner>
      </ng-container>
      <ng-container *ngIf="error">
        <div class="error-box">
          <h1>Uh oh!</h1>
          <p>Looks like we're having trouble loading this right now.
            Check your Internet connection and try again. If this issue persists please contact
            support&#64;tytnetwork.com.
          </p>
          <a class="btn btn-primary" onclick="window.location.reload()">Try again</a>
        </div>
      </ng-container>
    </div>
</ng-container>

<tyt-classic-offers *ngIf="offerSet && offersVersionToShow === 'classic'" 
 [offerSet]="offerSet"
 [offersGroups]="offersGroups"
 [user]="user"
 [backgroundImage]="currentBackgroundImage"></tyt-classic-offers>

<ng-template #offerSetTemplate>
</ng-template>

<tyt-staging-note class="pixel-debugger" *ngIf="enablePixelDebugger">
  <div class="property">
    Pixel: {{pixelImpression ? 'Sent' : 'Not Sent'}} [{{pixelEndpoint}}]
  </div>
</tyt-staging-note>